import { Tabs, Tooltip } from "antd";
import { LockOutlined } from "@ant-design/icons";
import React, { forwardRef, useState, useMemo } from "react";
import Insurance from "@/views/AccountPayable/Insurance";
import InsuranceByProp from "@/views/AccountPayable/InsuranceByProp";
import commonFn from "@/utils/commonFn";

const MainTable = forwardRef((props, ref) => {
  const [tabsKey, setTabsKey] = useState(1);

  const allTabs = useMemo(() => [
    {
      key: 1,
      label: "Insurance",
      children: <Insurance />,
      permissionKey: "insuranceIndex"
    },
    {
      key: 2,
      label: "Insurance By Prop",
      children: <InsuranceByProp />,
      permissionKey: "insuranceByProp"
    },
  ], []);

  
  const availableTabs = useMemo(() => {
    return allTabs.filter(tab => commonFn.btnAuthorityFlag(tab.permissionKey));
  }, [allTabs]);


  const defaultTabKey = useMemo(() => {
    return availableTabs[0]?.key || 1;
  }, [availableTabs]);

  React.useEffect(() => {
    if (availableTabs.length > 0 && !availableTabs.find(tab => tab.key === tabsKey)) {
      setTabsKey(availableTabs[0].key);
    }
  }, [availableTabs, tabsKey]);

  
  if (availableTabs.length === 0) {
    return (
      <div style={{ padding: "40px", textAlign: "center", color: "#999" }}>
        No permission to view any content
      </div>
    );
  }

  return (
    <div>
      <Tabs
        activeKey={tabsKey}
        forceRender
        items={availableTabs.map(({ key, label, children }) => ({
          key,
          label,
          children
        }))}
        onChange={key => setTabsKey(key)}
      />
    </div>
  );
});

export default MainTable;